import { render } from "./BrandRedmail.vue?vue&type=template&id=93b9206c"
import script from "./BrandRedmail.vue?vue&type=script&lang=ts"
export * from "./BrandRedmail.vue?vue&type=script&lang=ts"

import "./BrandRedmail.vue?vue&type=style&index=0&id=93b9206c&lang=scss"
script.render = render

export default script